import { useState, useEffect } from "react";
import {useNavigate, Link} from 'react-router-dom';
import {toast} from 'react-hot-toast'
import ReactGA from 'react-ga4';
import { useStyle } from "../../context/styleContext/styleContext";
import Button from '@mui/material/Button';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Checkbox, TextField, FormCOntrol, InputLabel, OutlinedInput, InputAdornment, FormControl, IconButton, FormGroup, FormControlLabel } from "@mui/material";
import { FaAngleLeft } from "react-icons/fa6";
import AlertModal from "../../components/AlertModal/AlertModal";
import Seo from "../../components/Seo";


//import IMAGES from "../../assets";
//import {Notify} from '../../utilities'

export default function ForgotPassword(){
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [tooManyRequests, setTooManyRequests] = useState(false);
  const { style } = useStyle();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
      setIsModalOpen(false);
      navigate('/login')

    }
  

    const [height, setHeight] = useState(window.innerHeight)
    const [width, setWidth] = useState(window.setWidth)
  
    useEffect(() => {
      function handleResize() {      
        setWidth(window.innerWidth)
        setHeight(window.innerHeight)
    }})


const navigate = useNavigate()



const navigateHome = async (e) => {
  navigate('/')
}

  const sendRequest = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // If any field is missing
    if (email) {
      //console.log('email is missing...')
      setIsLoading(false);
      try {
        const response = await fetch("https://api.parishaudio.com/api/forgot-password", {
        //const response = await fetch("http://localhost:8080/forgot_password", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
          }),
        });
        const data = await response.json();
        //console.log("RESPONSE ", data)

        if (data.success) {
          setIsLoading(false);
          setIsEmailSent(true);
          console.log("Success")
          openModal();
          //toast.success("Your request has been sent. Pleast check your email for a link to reset your password.")
          //return Notify(data.data, "success");
          
          
        }

        else if (response.status == 429)
        {
          
          setIsLoading(false);
          setTooManyRequests(true);
      
        }
  
        else if( response.status != 429 ){
          setIsLoading(false);
          openModal();
          //return Notify(data.error, "error");
          //toast.error("An error has occured, Please try again.")
        }
      } catch (error) {
        setIsLoading(false);
        console.log("catch error")
        openModal();
        //return Notify("Internal server error", "error");
        //toast.error("An error has occured, Please try again.")
      }
  
      //openModal();

    }
    else{
      toast.error("Please enter your email address");
    }

    
  };

  return (
    <>

    <Seo
      title="Forgot Password | Parish Audio"
      description="Reset your Parish Audio account password and regain access to your plugins, downloads, and account."
      canonical="https://parishaudio.com/forgot-password"
      robots="noindex,follow"
    />


{tooManyRequests && (<>
<div style={{width:'95%', maxWidth:'600px', margin:'auto', minHeight:height - 130}}>
  <div style={{margin:'auto', borderColor:style.color1, borderWidth:'2px', borderRadius:'10px', borderStyle:'solid', maxWidth:'600px', marginTop:'30px', backgroundColor:style.color4, textAlign:'center', minHeight:'500px'}}>
<h1 style={{marginBottom:'25px'}}>Daily Limit Reached</h1>
<p>
  You have reached your daily limit of password reset requests. Please try again in 24 hours.
</p>
<div style={{marginTop:'100px'}}>
<Button onClick={navigateHome} sx={{ my: 2, color:style.color4, display:'block', backgroundColor:style.color1, fontSize:'16pt', minWidth:'300px', margin:'auto', borderColor:style.color4, borderWidth:'2px', borderStyle:'solid', '&:hover': {backgroundColor: style.color2 }, }}>OK</Button>
</div>
</div>
</div>


          </>)}


      {!tooManyRequests && (
        <div style={{ minHeight:height - 130}}>
        <div style={{margin:'auto', borderColor:style.color1, borderWidth:'2px', borderRadius:'10px', borderStyle:'solid', maxWidth:'600px', marginTop:'30px', backgroundColor:style.color1}}>
         <div style={{margin:'auto', textAlign:'center', width:'90%'}}>
          <div>
            <h1 style={{marginBottom:'40px', marginTop:'30px'}}>Forgot your password?</h1>
            <h4>
            Enter the email associated with your account, and we will send instructions to reset your password.
            </h4>
          </div>
          <div>

         </div>
         <div style={{width:'90%', margin:'auto', marginTop:'50px'}}>
          <TextField
                id="outlined-basic"
                label="Email"
                variant="outlined"
                value= {email}
                onChange={(e) => setEmail(e.target.value)}
                size='small'
                fullWidth
                sx={{
                    backgroundColor: style.color2,
                    borderRadius:'4px',
                    '& .MuiInputBase-input': {
                    color: style.color4,  // Change the font color here
                    fontSize: '16pt',  // Change the font size here
                    boxShadow:10,
                                              
                    },
                    '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: style.color2, // Change the border color if needed
                        borderWidth:'1px'
                    },
                    '&:hover fieldset': {
                        filter:'brightness(1.2)', // Change the border color on hover if needed\
                        borderWidth:'1px',                                                               
                 
                        
                    },
                    '&.Mui-focused fieldset': {
                       // borderColor: style.color1, // Change the border color when focused if needed
                        //borderWidth:'3px'
                        borderColor:style.color2   
                        
                    },
                    '&.Mui-disabled': {
                        '& fieldset': {
                        borderColor: style.color1, // Change the border color when disabled
                        },
                    },
                    },
                    '& .MuiInputLabel-root': {
                    color: style.color3, // Change the label color here
                    fontSize:'16pt',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                    color: style.color3, // Change the label color when focused here   
                                               
                    },
                    '& .MuiInputLabel-root.Mui-disabled': {
                    color: style.color2, // Change the label color when disabled
                    },
                    '& .MuiInputBase-root.Mui-disabled': {
                    '& input': {
                        color: style.color2, // Change the input font color when disabled // so it works in safari
                        WebkitTextFillColor: style.color4, // so it works on chrome
                        fontSize:'16pt'
                    },
                    },
                    '& .MuiOutlinedInput-input': { color: style.color4,
                    '&:-webkit-autofill': { backgroundColor:style.color2, WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset',
                        WebkitTextFillColor: style.color4, color:style.color4, borderColor:style.color2
                     }, }, 
                }}
                />
                </div>
                <div style={{marginTop:'50px', marginBottom:'30px', display:'flex', flex:1}}>
                    <Button onClick={sendRequest} sx={{ my: 2, boxShadow:10,color:style.color4, display:'block', backgroundColor:style.color1, fontSize:'16pt', minWidth:'300px', margin:'auto', marginTop:'0px', borderColor:style.color2, borderWidth:'1px', borderStyle:'solid', '&:hover': {filter:'brightness(1.5)' }, }}>Send Link</Button>
                </div>
                <div style={{display:'flex', marginBottom:'50px', flexDirection:'row'}}>  
                  <div style={{margin:'auto', flex:1, flexDirection:'row'}}>
                    
                 
                    <div >
                      
                    <div>
                    <Link to='/login' style={{fontSize:'1.3em', fontWeight:'bold', textAlign:'center', color:style.color4, margin:'auto', alignContent:'center', textAlign:'center'}}>
                         Back To Login
                      </Link>
                    </div>

                    </div>
                    
                    

                  

                  </div>

                <Link to='/login' style={{fontSize:'1.3em', fontWeight:'bold', textAlign:'center', color:style.color4, margin:'auto', alignContent:'center'}}>
                
                
                </Link>
                </div>
                
               
          </div>
          <div id='modal-root'>
            <AlertModal message={"A password reset link has been sent to your email. Please follow the instructions contained in the email to reset your password."} buttonText={'Proceed To Login'} isOpen={isModalOpen} close={closeModal}>
                
            </AlertModal>
            </div>
        </div>

</div>

      )}
    </>
  );
};

